import http from '../plugins/axios'; 

export async function get_credits(payload) {
    const response = await http.get('cashier/creditPayment',  { params: payload });
    return response.data;
}

export async function confirmPayCredit(payload) {
    const response = await http.post('cashier/order/mulit-pay-order', payload);
    return response.data;
}

export async function getCustomers(payload) {
    const response = await http.get('cashier/custCredit',  { params: payload });
    return response.data;
}

 